import { useState, useEffect } from 'react';
import { useSecureAuth } from '../contexts/SecureAuthContext';

const useMerchantStatus = () => {
  const [statusError, setStatusError] = useState(null);
  const { user, getAxios } = useSecureAuth();

  useEffect(() => {
    const checkMerchantStatus = async () => {
      if (!user || user.role !== 'merchant') return;

      try {
        const axios = getAxios();
        const response = await axios.get('/stores/me');

        if (response.status === 403) {
          const errorData = response.data;
          if (errorData.error === 'Account banned' || errorData.error === 'Account suspended') {
            setStatusError(errorData);
          }
        }
      } catch (error) {
        console.error('Error checking merchant status:', error);
        if (error.response?.status === 403) {
          const errorData = error.response.data;
          if (errorData.error === 'Account banned' || errorData.error === 'Account suspended') {
            setStatusError(errorData);
          }
        }
      }
    };

    checkMerchantStatus();
  }, [user, getAxios]);

  return statusError;
};

export default useMerchantStatus;


